module.exports = __webpack_public_path__ + "img/information_large.bd09b651.png";